import { InboxClassificationFilter } from 'owa-mail-list-store';

const INBOX_PREVIEW_SVG = require('../svg/Inbox.svg');
const FOCUSED_PREVIEW_SVG = require('../svg/FocusedInbox.svg');
const PROMOTIONS_PREVIEW_SVG = require('../svg/promos.svg');
const SOCIAL_PREVIEW_SVG = require('../svg/like.svg');
const NEWSLETTERS_PREVIEW_SVG = require('../svg/newsletters.svg');
const OTHER_PREVIEW_SVG = require('../svg/other.svg');

export const getPivotPreviewSvg = (pivot: InboxClassificationFilter): string => {
    switch (pivot) {
        case InboxClassificationFilter.None:
            return INBOX_PREVIEW_SVG;
        case InboxClassificationFilter.Focused:
            return FOCUSED_PREVIEW_SVG;
        case InboxClassificationFilter.Promotions:
            return PROMOTIONS_PREVIEW_SVG;
        case InboxClassificationFilter.Social:
            return SOCIAL_PREVIEW_SVG;
        case InboxClassificationFilter.Newsletters:
            return NEWSLETTERS_PREVIEW_SVG;
        case InboxClassificationFilter.Other:
            return OTHER_PREVIEW_SVG;
        default:
            return null;
    }
};
